
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'pvp-hint',
  props: {
    text: String,
  },
});
